/**
 * difficulty.ts — pure, no Phaser import.
 *
 * Returns per-difficulty multipliers used by StageScene (enemy spawn) and
 * CombatSystem (player damage). All values are relative to pub (baseline = 1).
 */

import type { Difficulty } from '@/state/GameState';

export interface DifficultyMods {
  /** Scale applied to each enemy's maxHp on spawn. */
  enemyHpMult: number;
  /** Scale applied to each wave's enemy counts on spawn (clamped ≥ 1). */
  enemyCountMult: number;
  /** Scale applied to each enemy's movement speed on spawn. */
  enemySpeedMult: number;
  /** Scale applied to damage dealt by player-team hitboxes. */
  playerDamageMult: number;
}

const MODS: Record<Difficulty, DifficultyMods> = {
  pint: { enemyHpMult: 0.8, enemyCountMult: 0.8, enemySpeedMult: 0.9, playerDamageMult: 1.1 },
  pub: { enemyHpMult: 1.0, enemyCountMult: 1.0, enemySpeedMult: 1.0, playerDamageMult: 1.0 },
  brawl: { enemyHpMult: 1.3, enemyCountMult: 1.25, enemySpeedMult: 1.15, playerDamageMult: 1.0 },
  manor: { enemyHpMult: 1.6, enemyCountMult: 1.5, enemySpeedMult: 1.3, playerDamageMult: 0.9 },
};

export function difficultyMods(d: Difficulty): DifficultyMods {
  return MODS[d];
}
